// lib/mock/products.ts
import type { Product } from "@/types";

// ─── داده‌های تستی محصولات ───
export const MOCK_PRODUCTS: Product[] = [
  {
    id: 164224,
    name: "پودر قهوه امریکانو کلاسنو ۲۴۰ گرمی",
    slug: "پودر-قهوه-امریکانو-کلاسنو-164224",
    price: 801960,
    oldPrice: 978000,
    off: 18,
    image: "/image/products/164224-185x226.webp",
    description: "قهوه تازه آسیاب شده با عطر و طعم بی‌نظیر...",
    categoryId: 5,
    categoryName: "نوشیدنی و دمنوش‌ها",
    brandId: 9,
    brandName: "کلاسنو",
    stock: 24,
    rating: 4.5,
    isActive: true,
    createdAt: Date.now() - 30 * 86400000,
  },
  {
    id: 166798,
    name: "تخم مرغ توتک ۳۰ عددی",
    slug: "تخم-مرغ-توتک-166798",
    price: 582505,
    oldPrice: 685300,
    off: 15,
    image: "/image/products/166798-185x226.webp",
    description: "تخم مرغ تازه و با کیفیت...",
    categoryId: 2,
    categoryName: "پروتئینی",
    brandId: 4,
    brandName: "دامداران",
    stock: 50,
    rating: 4.7,
    isActive: true,
    createdAt: Date.now() - 20 * 86400000,
  },
  // ... سایر محصولات
];


// ─── تایپ‌ها و داده‌های مدیریت قالب صفحه محصول (PDP Builder) ───

export interface PdpBlockConfig {
  displayType?: string;
  dataSource?: string;
  [key: string]: any;
}

export interface PdpBlock {
  id: string;
  type: string;
  name: string;
  isActive: boolean;
  config?: PdpBlockConfig;
}

export interface PdpText {
  key: string;
  value: string;
  usage: string;
}

export const MOCK_PDP_BLOCKS: PdpBlock[] = [
  { id: "b1", type: "gallery", name: "گالری تصاویر", isActive: true },
  { id: "b2", type: "info", name: "اطلاعات پایه و امتیاز", isActive: true },
  { id: "b3", type: "price", name: "قیمت و تایمر", isActive: true },
  { id: "b4", type: "stock_badge", name: "وضعیت انبار (هشدار موجودی)", isActive: true },
  { 
    id: "b5", 
    type: "product_slider", 
    name: "اسلایدر لوازم جانبی", 
    isActive: true,
    config: { displayType: "special", dataSource: "complementary_tags" }
  },
  { id: "b6", type: "custom_banner", name: "بنر تبلیغاتی بین محتوا", isActive: false },
  { id: "b7", type: "specs", name: "مشخصات فنی", isActive: true },
  { id: "b8", type: "description", name: "توضیحات محصول", isActive: true },
  { id: "b9", type: "reviews", name: "نظرات کاربران", isActive: true },
  { 
    id: "b10", 
    type: "product_slider", 
    name: "اسلایدر محصولات مشابه", 
    isActive: true,
    config: { displayType: "grid", dataSource: "similar_category" }
  },
];

export const MOCK_PDP_TEXTS: PdpText[] = [
  { key: "pdp.actions.add_to_cart", value: "افزودن به سبد", usage: "دکمه پایین صفحه (ProductActions)" },
  { key: "pdp.actions.out_of_stock", value: "این محصول در حال حاضر ناموجود است", usage: "دکمه در حالت اتمام موجودی" },
  { key: "pdp.price.your_profit", value: "سود شما", usage: "جعبه قیمت (ProductPrice)" },
  { key: "pdp.stock.out_desc", value: "این محصول فعلاً موجود نیست. به‌زودی شارژ می‌شود.", usage: "هشدار اتمام انبار (ProductStockBadge)" },
  { key: "pdp.stock.low_stock", value: "برای اطمینان از خرید، همین حالا سفارش دهید.", usage: "هشدار موجودی کم" },
  { key: "pdp.shipping.free", value: "سفارش بالای X تومان ارسال رایگان دارد", usage: "جعبه ارسال (ProductShippingInfo)" },
  { key: "pdp.reviews.title", value: "نظرات کاربران", usage: "عنوان بخش نظرات" },
  { key: "pdp.reviews.empty", value: "هنوز نظری ثبت نشده. اولین نفر باشید!", usage: "وقتی نظری وجود ندارد" },
  { key: "pdp.reviews.show_all", value: "نمایش همه", usage: "دکمه گسترش نظرات" },
  { key: "pdp.features.title", value: "ویژگی‌های کلیدی", usage: "بخش ویژگی‌های بولت‌دار" },
  { key: "pdp.specs.title", value: "مشخصات فنی", usage: "عنوان آکاردئون مشخصات" },
  { key: "pdp.toast.copied", value: "لینک محصول کپی شد", usage: "ProductHeader (Share)" },
  { key: "pdp.toast.added_to_cart", value: "به سبد خرید اضافه شد", usage: "ProductPageClient (پس از افزودن)" },
  { key: "pdp.toast.favorite_add", value: "به علاقه‌مندی‌ها اضافه شد", usage: "ProductGallery" },
];